import React from 'react';
//ions
import { BiHomeAlt, BiUser } from 'react-icons/bi';
import { BsClipboardData, BsBriefcase, BsChatSquareText } from 'react-icons/bs';
//links
import { Link } from 'react-scroll';


const Nav = () => {
  const getOffset = () => {
    if (window.innerWidth >= 960) return -200;  // lg
    if (window.innerWidth >= 778) return -100;  // md
    return -144; // sm
  };

  return (
    <nav className='fixed bottom-2 lg:bottom-8 overflow-hidden w-full z-50 '>
      <div className='container mx-auto'>
        <div className='w-full bg-black/60 h-[96px] backdrop-blur-2xl rounded-full max-w-[460px] mx-auto px-5 flex justify-between items-center text-2xl text-white '>
          <Link to='home'
            activeClass='active'
            smooth={true}
            spy={true}
            offset={getOffset()}
            className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center '>
            <BiHomeAlt className='text-2xl' />
          </Link>

          <Link to='about'
            activeClass='active'
            smooth={true}
            spy={true}
            offset={-5}
            className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center '>
            <BiUser className='text-2xl '/>
          </Link>

          <Link to='services'
            activeClass='active'
            smooth={true}
            spy={true}
            offset={-5}
            className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center '>
            <BsClipboardData className='text-2xl'/>
          </Link>

          <Link to='work'
            activeClass='active'
            smooth={true}
            spy={true}
            offset={-5}
            className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center '>
            <BsBriefcase className='text-2xl'/>
          </Link>

          <Link to='contact'
            activeClass='active'
            smooth={true}
            spy={true}
            offset={-5}
            className='cursor-pointer w-[60px] h-[60px] flex items-center justify-center '>
            <BsChatSquareText  className='text-2xl'/>
          </Link>
        </div>
      </div>

    </nav>
  );
};

export default Nav;
